import React from "react";
import { Link } from "react-router";

import "./Error404.scss";

const Error404 = () => (
	<div className="error-404">
		<i className="rkf rkf-rollkall-logo" />
		<h1>404</h1>
		<p>Page not found</p>
		<Link
			to="/"
			className="btn btn-success"
		>
			Go to home page
		</Link>
	</div>
);

export default Error404;
